import { Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import CustomTag from "components/Atoms/CustomTag"
import Error from "components/Common/Error"
import CustomOverflowList from "components/Molecules/CustomOverflowList"
import ImageStack from "components/Organisms/ImageStack"
import DataCell, { Subtitle, Title } from "components/Organisms/table/DataCell"
import SerialColumn from "components/Organisms/table/SerialColumn"
import CustomReactTable from "components/Templates/CustomReactTable"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import { useAllPriceBenchmarkData } from "graphql/benchmark.graphql.gql"
import React from "react"
import { readableDate } from "utils/custom.utils"
import BenchmarkHeader from "./benchmarks/BenchmarkHeader"
import CustomCard from "components/Atoms/CustomCard"
dayjs.extend(advancedFormat)
// import { useRetailGroups } from "graphql/vendor/vendor.hooks";
const Benchmarks = () => {
  const { data, loading, error } = useAllPriceBenchmarkData()
  // const groups = useRetailGroups();
  if (error) return <Error message={error?.message} />
  const COLUMNS = [
    SerialColumn,
    {
      width: 150,
      Header: "Date",
      accessor: "metadata.date",
      Cell({ value }) {
        return readableDate(value)
      },
    },
    {
      width: 200,
      Header: "Crop",
      accessor: "metadata.commodityGroup.name",
      Cell({ value, original }) {
        return (
          <DataCell>
            <Title>{value}</Title>
            <Subtitle>{original?.grade.name}</Subtitle>
          </DataCell>
        )
      },
    },

    {
      width: 180,
      Header: "Seller",
      accessor: "metadata.seller.name",
      Cell({ value, original }) {
        return (
          <DataCell>
            <Title>{value}</Title>
            <Subtitle>{original?.metadata.seller.categoryObj.name}</Subtitle>
          </DataCell>
        )
      },
    },
    {
      width: 220,
      Header: "Market Yard",
      accessor: "metadata.marketYard",
      Cell({ value, original }) {
        return (
          <DataCell>
            <Title>{value?.name}</Title>
            <Subtitle>{value?.address.village}</Subtitle>
          </DataCell>
        )
      },
    },
    {
      Header: "Grade Prices",
      accessor: "gradePrices",
      Cell({ value: prices }) {
        return (
          <>
            <CustomOverflowList
              // Filter out all the photos that do not have a url
              items={prices ?? []}
              overflowRenderer={prices => {
                return (
                  <CustomPopover
                    minimal
                    position={Position.BOTTOM_LEFT}
                    key={prices?.length}
                    content={
                      <Menu className="vt-overflow-list-menu">
                        {prices?.map((item: any) => {
                          return (
                            <MenuItem
                              key={item?.id}
                              text={
                                <>
                                  <span>₹{item?.price}/</span>
                                  <span className="vt-highlight">
                                    {item?.uomType?.codename}
                                  </span>
                                </>
                              }
                            />
                          )
                        })}
                      </Menu>
                    }
                  >
                    <CustomTag
                      className="ml-3"
                      interactive
                      round
                      intent="primary"
                      minimal
                    >
                      + {prices?.length}
                    </CustomTag>
                  </CustomPopover>
                )
              }}
              visibleItemRenderer={(item: any) => {
                //
                return (
                  <span className="ml-3" key={item?.id}>
                    <span>₹{item?.price} / </span>
                    {item?.pricingDoneOn === "UOM" ? (
                      <span className="vt-highlight">
                        {item?.uomType?.codename}
                      </span>
                    ) : (
                      <span className="vt-highlight">
                        {item?.priceUnit?.name}
                      </span>
                    )}{" "}
                  </span>
                )
              }}
            />
          </>
        )
      },
    },
    {
      // width: 400,
      Header: "Photos",
      accessor: "photos",
      Cell({ value: photos }) {
        return <ImageStack photos={photos} />
      },
    },
  ]

  return (
    <CustomCard className="m-3 p-0">
      <BenchmarkHeader />
      <CustomReactTable
        showPaginationBottom={false}
        data={data?.allPriceBenchmarkData ?? []}
        loading={loading}
        columns={COLUMNS}
      />
    </CustomCard>
  )
}

export default Benchmarks
